// 获取当前环境变量
const isDev = () => {
  return process.env.MODE === "development";
};

const isProd = () => {
  return process.env.MODE === "production";
};

export { isDev, isProd };
